import styled from 'styled-components';
import { Button, Heading } from 'components';

export const Wrapper = styled.div`
  margin-bottom: ${props => props.theme.spacing.default};
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${props =>
    `${props.theme.spacing.default} ${props.theme.spacing.default}`};
  background-color: ${props => props.theme.color.wfGrey100};
  color: ${props => props.theme.color.wfGrey900};
  cursor: ${props => (props.isExpanded && 'default') || 'pointer'};
  border-bottom: ${props =>
    props.isExpanded && `1px solid ${props.theme.color.wfGrey200}`};
  transition: background-color ease 0.2s;
  &:hover {
    background-color: ${props =>
      !props.isExpanded && props.theme.color.wfGrey200};
  }
`;

export const Salary = styled.small`
  display: block;
  font-weight: ${props => props.theme.font.weight.regular};
  line-height: 1.4;
  white-space: pre;
  margin-top: ${props => props.theme.spacing.xsmall};
`;

export const HeadingStyled = styled(Heading)`
  > ${Salary} {
    font-size: 80%;
  }
`;

export const ButtonStyled = styled(Button)`
  margin: ${props => props.theme.spacing.small} 0;
`;

export const Body = styled.div`
  padding: ${props => props.theme.spacing.default};
  line-height: 1.5;
  font-size: ${props => props.theme.font.size.default};
  display: ${props => (props.isVisible ? 'block' : 'none')};
  p {
    margin-bottom: ${props => props.theme.spacing.default};
  }
  ul {
    margin: 0 0 ${props => props.theme.spacing.default} 0;
    padding-left: ${props => props.theme.spacing.medium};
    list-style: disc;
    > li {
      line-height: 1.5;
    }
  }
`;
